import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type ALERT_TYPE = 'success' | 'error' | 'info';
const TYPE_TO_BOOTSTRAP_CLASS_MAP: Record<ALERT_TYPE, string> = {
  success: 'success',
  error: 'danger',
  info: 'info',
};

@Component({
  selector: 'app-alert',
  imports: [],
  host: {
    '[class]': `hostClass()`,
  },
  templateUrl: './alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  public withIcon = input<boolean>(false);
  public alertType = input.required<ALERT_TYPE>();
  public hostClass = computed(() => `tw-block message-${TYPE_TO_BOOTSTRAP_CLASS_MAP[this.alertType()]}`);
}
